/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { GmcError } from '@app/core/types';
import { createAction, props } from '@ngrx/store';
import { ClusterId } from '@shared/types/cluster';
import { Team, TeamId } from '@shared/types/team';

export const teamList = createAction('[Teams] Teams', props<{ data: Team[] }>());

export const removeClusterFromTeam = createAction(
  '[Teams] Remove cluster from team',
  props<{ clusterId: ClusterId; teamId: TeamId }>(),
);
export const removeClusterFromTeamOK = createAction(
  '[Teams] Remove cluster from team OK',
  props<{ clusterId: ClusterId; teamId: TeamId; notification?: string }>(),
);
export const removeClusterFromTeamErr = createAction(
  '[Teams] Remove cluster from team err',
  props<GmcError & { clusterId: ClusterId; teamId: TeamId }>(),
);

export const shareCluster = createAction('[Teams] Share cluster', props<{ clusterId: ClusterId; names: string[] }>());
export const shareClusterOK = createAction(
  '[Teams] Share cluster OK',
  props<{ clusterId: ClusterId; names: string[]; notification?: string }>(),
);
export const shareClusterErr = createAction(
  '[Teams] Share cluster err',
  props<GmcError & { clusterId: ClusterId; names: string[] }>(),
);
export const shareClusterValidationErr = createAction('[Teams] Share cluster Validation err', props<GmcError>());
export const stopShareWithClusterIntent = createAction(
  '[Teams] Stop share with cluster intent',
  props<{ clusterId: ClusterId; teamId: TeamId }>(),
);
